export default "__VITE_ASSET__u0kkWYbX__"